<template>
    <div class="z-page-nav" v-if="nav">
        <div class="z-page-nav__inner">
            <a
                v-if="nav.prev && nav.prev.text"
                :href="nav.prev ? nav.prev.link : 'javascript:void(0)'"
                :title="nav.prev.text"
                class="z-page-nav__btn z-page-nav__btn--prev"
                :class="!nav.prev && 'z-page-nav__btn--disabled'"
            >
                <z-icon name="arrow" dir="left" width="20" height="34" />
            </a>
            <div class="z-page-nav__divider">
                <z-icon name="sg-element" width="22" height="22" />
            </div>
            <a
                v-if="nav.next && nav.next.text"
                :href="nav.next ? nav.next.link : 'javascript:void(0)'"
                :title="nav.next.text"
                class="z-page-nav__btn z-page-nav__btn--next"
                :class="!nav.next && 'z-page-nav__btn--disabled'"
            >
                <z-icon name="arrow" dir="right" width="20" height="34" />
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'z-page-nav',
    computed: {
        nav () {
            return this.$root.app.components['page-nav'] ? this.$root.app.components['page-nav'] : null
        }
    }
}
</script>

<style lang="scss">
.z-page-nav {
    position: relative;
    @include padding-level(left, M);
    overflow: hidden;

    &:before {
        content: '';
        display: block;
        top: 0;
        left: 0;
        height: 100%;
        position: absolute;
        background: red;
        background: rgba($token-colors-secondary-bg, 0.8);
        transform: skewX(-27deg) translateX(29px);
        width: 100%;
    }

    &__inner {
        display: flex;
        width: 100%;
        justify-content: center;
        position: relative;
    }

    &__divider {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
        margin-left: -2px;

        .z-icon path {
            fill: $token-colors-white;
        }
    }

    &__btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 50%;
        @include padding-level(top, S);
        @include padding-level(bottom, S);

        @include breakpoint (mobile) {
            padding-top: 8px;
            padding-bottom: 8px;
        }

        .z-icon {
            position: relative;
            z-index: 1;

            @include breakpoint (mobile) {
                height: 28px !important;
                width: auto;
            }

            path {
                fill: $token-colors-black-80;
                transition: all $transition;
            }
        }

        &--prev {}

        &--next {}

        &--disabled {
            pointer-events: none;

            // .z-icon {
            //     path {
            //         fill: $token-colors-black-40;
            //     }
            // }
        }

        &:hover {
            // &:before {
            //     background-color: $token-colors-primary;
            // }
            //
            .z-icon path {
                fill: $token-colors-link-hover;

            }
        }

    }
}
</style>
